module.exports = __webpack_public_path__ + "media/images/metronic/portlet-collapse-icon-white-b88dc455f41c2c1c4d5fd2078187412d.png";